export const immobiliareBaseUrl: string = String(window.globalVars?.IMMOBILIARE_BASEURL);
